import * as Rx from 'rxjs';
import { distinctUntilChanged, map, scan } from 'rxjs/operators';

import { BaseReactionProps } from '../BaseReaction';
import { ReactionOptions } from '../BaseReactionSVG';

import { HoverType } from './getMolDrawers';
import { HoverState, buildHoverState } from './buildHoverState';

const isMacOS = (): boolean => {
  return window.navigator.userAgent.includes('Macintosh');
};

export function getInputStream(props: Partial<BaseReactionProps>, options: ReactionOptions): Rx.Subject<HoverState> {
  const { ref, alignedSubstrateMols, mapToProduct, mapToSubstrates } = options;

  const inputStateAccumulatorSeed = {
    ctrl: false,
    shift: false,
    alt: false,
    state: {
      substrateIndex: null,
      mapId: null,
    },
  };

  const inputStream = new Rx.Subject<React.MouseEvent | React.KeyboardEvent>();

  return inputStream.pipe(
    map(event => {
      const modifiers: any = {
        ctrl: (event.type !== 'keyup' && event.ctrlKey) || (event.metaKey && isMacOS()),
        shift: event.type !== 'keyup' && event.shiftKey,
        alt: event.type !== 'keyup' && event.altKey,
        state: {
          substrateIndex: null,
          mapId: null,
        },
      };

      if (event.type === 'mousemove') {
        modifiers.state = buildHoverState(props, {
          event,
          ref,
          alignedSubstrateMols,
          mapToProduct,
          mapToSubstrates,
        });
      }

      return modifiers;
    }),
    scan((acc, nxt) => ({ ...acc, ...nxt }), inputStateAccumulatorSeed),
    map(({ ctrl, shift, alt, state: { mapId, substrateIndex } }) => {
      if (alt && substrateIndex != null && mapId != null) {
        return { type: HoverType.HOVER_ATOM, substrateIndex, mapId };
      }

      if (ctrl && substrateIndex != null) {
        return { type: HoverType.HOVER_MOL, substrateIndex, mapId: null };
      }

      if (shift && mapId != null) {
        return { type: HoverType.HOVER_ALL, substrateIndex: null, mapId: null };
      }

      return { type: HoverType.HOVER_NONE, substrateIndex: null, mapId: null };
    }),
    distinctUntilChanged((a, b) => a.type === b.type && a.mapId === b.mapId && a.substrateIndex === b.substrateIndex)
  ) as Rx.Subject<HoverState>;
}
